import { FC } from 'react'
import { useSwiperSlide } from 'swiper/react'

import { Content, ContentType } from '../../../types/Content'
import { ExerciseProps } from '../../../common/utils/feed'
import { ResponseStatus } from '../../../common/utils/exercise'
import VideoPlayer from './VideoPlayer'
import ContentBase from '../ContentBase'
import ImageCarousel from './ImageCarousel'

interface MediaPostProps {
  post: Content
  isExercise?: boolean
  exerciseProps?: ExerciseProps
  contentType: ContentType
}

const MediaPost: FC<MediaPostProps> = ({
  exerciseProps,
  isExercise = false,
  post,
  contentType,
}) => {
  const { title, data, context, type } = post
  const { isActive, isNext, isPrev, isVisible } = useSwiperSlide()

  const isVideo =
    contentType === ContentType.YOUTUBE ||
    (contentType === ContentType.INSTAGRAM && data.meta?.type === 'GraphVideo')

  const isActiveAndVisible = isActive && isVisible && !isNext && !isPrev
  if (isExercise && isActiveAndVisible && !exerciseProps?.stepResponse) {
    exerciseProps?.onResponseSubmit(exerciseProps?.id, ResponseStatus.COMPLETE)
  }

  const shortCode = data.meta?.shortcode
  let extension = '.mp4'
  let source = ''

  if (contentType === 'INSTAGRAM') {
    switch (data.meta.type) {
      case 'GraphVideo':
        extension = '.mp4'
        break
      case 'GraphImage':
        extension = '.jpg'
        break
    }

    source = `${process.env.REACT_APP_BASE_URL}/media/${shortCode}${extension}`
  } else if (contentType === 'YOUTUBE') {
    source = `${process.env.REACT_APP_BASE_URL}/media/${shortCode}${extension}`
  }

  if (isVideo) {
    return isExercise ? (
      <VideoPlayer url={source} />
    ) : (
      <ContentBase context={context} data={data} title={title} type={type}>
        <VideoPlayer url={source} />
      </ContentBase>
    )
  } else {
    return isExercise ? (
      <img style={{ width: '100%' }} src={source} alt={title} />
    ) : (
      <ContentBase context={context} data={data} title={title} type={type}>
        {data.meta.type === 'GraphSidecar' ? (
          <ImageCarousel items={data.meta.items} shortCode={shortCode} />
        ) : (
          <img style={{ width: '100%' }} src={source} alt={title} />
        )}
      </ContentBase>
    )
  }
}

export default MediaPost
